
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { LineChartIcon, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import LineChartDisplay from "../charts/LineChartDisplay";

interface NaleveringenTabProps {
  orderStatusData: any[];
  monthlyOrdersData: any[];
}

const NaleveringenTab: React.FC<NaleveringenTabProps> = ({
  orderStatusData,
  monthlyOrdersData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Naleveringen per maand</CardTitle>
            <CardDescription>Trend in naleveringen over tijd</CardDescription>
          </div>
          <LineChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <LineChartDisplay 
            data={monthlyOrdersData}
            dataKey="orders"
            lineName="Naleveringen"
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Redenen voor naleveringen</CardTitle>
            <CardDescription>Verdeling van oorzaken</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={orderStatusData} />
        </CardContent>
      </Card>
    </div>
  );
};

export default NaleveringenTab;
